import React from 'react';
import { Menu } from './containers/Menu';
import { PrivateRoutes } from './containers/routes/PrivateRoutes';
import { PublicRoutes } from './containers/routes/PublicRoutes';
import { useAuthUser } from './containers/AuthProvider';

const App = () => {
  const user = useAuthUser();
  return <div id="layout">
    <a href="/" id="menuLink" className="menu-link">
      <span/>
    </a>
    <Menu/>
    <div id="main">
      {user && <PrivateRoutes/>}
      {!user && <PublicRoutes/>}
    </div>
    <div id="footer">
      <div id="lastStatus">
      </div>
    </div>
  </div>;
};

export default App;
